import React, { Component } from 'react';
import { Image, Button } from 'semantic-ui-react';

import success_img from 'images/success.png';
import fail_img from 'images/fail.png';

class ResultPage extends Component {

  render() {

    const { success, continueBtn, checkBtn } = this.props;

    let result_txt = "";
    if(success) {
      result_txt = "완료되었습니다.";
    } else {
      result_txt = "실패했습니다.";
    }

    return(
      <div className='final-page'>

        {
          success
          ? <Image src={success_img} centered/>
          : <Image src={fail_img} centered/>
        }

        <div className='align-center text'>
          {result_txt}
        </div>

        <div className='align-center btns'>
          <Button inverted color='black' onClick={continueBtn}>지급/차감 계속하기</Button>
          <Button color='black' onClick={checkBtn}>내역 확인하기 &gt;</Button>
        </div>

      </div>
    );
  }

}

export default ResultPage;
